/**
 * The demo's one real action: leave the demo for a live workspace.
 *
 * Only an administrator can do it (the backend refuses anyone else); other
 * staff are told who to ask.
 */
import { useState } from 'react'
import { usePermission } from '@lipaflow/shared'
import { goLiveFromDemo } from '../../services/goLive'

export default function DemoGoLiveButton({ className = '' }: { className?: string }) {
  const canManageUsers = usePermission('users:manage')
  const [pending, setPending] = useState(false)
  const [error, setError] = useState<string | null>(null)

  if (!canManageUsers) {
    return <p className="text-caption text-stone-500">Ask your administrator to take the workspace live.</p>
  }

  const onClick = async () => {
    setPending(true)
    setError(null)
    try {
      window.location.assign(await goLiveFromDemo())
    } catch (err) {
      const detail = (err as { response?: { data?: { detail?: unknown } } }).response?.data?.detail
      setError(typeof detail === 'string' ? detail : 'We could not create your workspace. Try again in a moment.')
      setPending(false)
    }
  }

  return (
    <div className="flex flex-col items-end gap-1">
      <button type="button" onClick={onClick} disabled={pending} className={className}>
        {pending ? 'Creating your workspace…' : 'Go live'}
      </button>
      {error && <p role="alert" className="text-caption text-error-600">{error}</p>}
    </div>
  )
}
